import React from 'react';
import PropTypes from 'prop-types';

import SearchBarResultsList from './searchBarResultsList';

class SearchBarContainer extends React.Component {
  constructor(props) {
    super(props);

    // this.defaultOnChange = this.defaultOnChange.bind(this);
    this.defaultOnFocus = this.defaultOnFocus.bind(this);
    this.defaultOnBlur = this.defaultOnBlur.bind(this);
    this.defaultDisplay = this.defaultDisplay.bind(this);
    this.defaultOnSelect = this.defaultOnSelect.bind(this);
    this.defaultOnKeyPress = this.defaultOnKeyPress.bind(this);
    this.defaultOnKeyDown = this.defaultOnKeyDown.bind(this);
    this.defaultOnKeyUp = this.defaultOnKeyUp.bind(this);
  }

  defaultOnChange() {
  	return null;
  }
  defaultOnFocus() {
  	return null;
  }
  defaultOnBlur() {
  	return null;
  }
   defaultDisplay() {
  	return null;
  }
  defaultOnSelect(selectedUser) {
  	return this.onSelect(selectedUser)
  }	
  defaultOnKeyPress() {
  	return null;
  }
  defaultOnKeyDown(event) {
  	if (event.key === 'Enter')
    	this.onSelect();
  }
  defaultOnKeyUp() {
  	return null;
  }

  render() {
  	let customContainerClass;
  	let customInputClass;
  	let placeHolder;
  	let customButtonClass;
  	let onSubmitButtonPress;
  	let onChange;
  	let onFocus;
  	let onBlur;
  	let onKeyPress;
  	let onKeyDown;
  	let onKeyUp;
  	let autoFocus;
  	let customResultsListClass;
  	let options;
  	let show;
  	let maxShow;
  	let customListItemClass;
  	let display;
  	let onSelect;

  	/*** CONTAINER PROPS ***/
  	
  	if(this.props.customContainerClass)
  		customContainerClass = this.props.customContainerClass;
  	else
  		customContainerClass = '';

  	/*** INPUT PROPS ***/

  	if(this.props.customInputClass)
  		customInputClass = this.props.customInputClass;
  	else
  		customInputClass = '';
  	if(this.props.placeHolder)
  		placeHolder = this.props.placeHolder;
  	else
  		placeHolder = '';
  	if(this.props.customButtonClass)
  		customButtonClass = this.props.customButtonClass;
  	else
  		customButtonClass = '';
  	if(this.props.onSubmitButtonPress)
  		onSubmitButtonPress = this.props.onSubmitButtonPress;
  	else
  		onSubmitButtonPress = null;
  	if(this.props.onChange)
  		onChange = this.props.onChange;
  	else
  		onChange = this.defaultOnChange;
  	if(this.props.onFocus)
  		onFocus = this.props.onFocus;
  	else
  		onFocus = this.defaultOnFocus;
  	if(this.props.onBlur)
  		onBlur = this.props.onBlur;
  	else
  		onBlur = this.defaultOnBlur;
  	if(this.props.onKeyPress)
  		onKeyPress = this.props.onKeyPress;
  	else
  		onKeyPress = this.defaultOnKeyPress;
  	if(this.props.onKeyDown)
  		onKeyDown = this.props.onKeyDown;
  	else
  		onKeyDown = this.defaultOnKeyDown;
  	if(this.props.onKeyUp)
  		onKeyUp = this.props.onKeyUp;
  	else
  		onKeyUp = this.defaultOnKeyUp;
  	if(this.props.autoFocus)
  		autoFocus = this.props.autoFocus;
  	else
  		autoFocus = false;

  	/*** RESULTS LIST PROPS ***/

  	if(this.props.customResultsListClass)
  		customResultsListClass = this.props.customResultsListClass;
  	else
  		customResultsListClass = '';
  	if(this.props.options)
  		options = this.props.options;
  	else
  		options = [];
  	if(this.props.show !== undefined)
  		show = this.props.show;
  	else
  		show = true;
  	if(this.props.maxShow)
  		maxShow = this.props.maxShow;
  	else
  		maxShow = 100;

  	/*** INDIVIDUAL RESULT PROPS ***/

  	if(this.props.customListItemClass)
  		customListItemClass = this.props.customListItemClass;
  	else
  		customListItemClass = '';
  	if(this.props.display)
  		display = this.props.display;
  	else
  		display = this.defaultDisplay;
  	if(this.props.onSelect)
  		onSelect = this.props.onSelect;
  	else
  		onSelect = null;
    return (
  		<div className={customContainerClass || 'search-bar-container'}>
  			<div className='form-group'>
	  			<div className='input-group input-search'>
		  			<input
		  				className='form-control search-bar-input'
		  				placeholder={placeHolder}
		  				value={this.props.value}
		  				onChange={onChange}
		  				onFocus={onFocus}
		  				onBlur={onBlur}
		  				onKeyPress={onKeyPress}
					  	onKeyDown={onKeyDown}
					  	onKeyUp={onKeyUp}
					  	autoFocus={autoFocus}
		  			/>
		  			<span className='input-group-btn'>
		  			<button 
		      		className='btn btn-default'
		      		onClick={onSubmitButtonPress}>
		      		<i className='fa fa-search' />
		      	</button>
		      	</span>
	      	</div>
	  			{(() => {
	  				if(show) {
	  					return (
	  						<SearchBarResultsList
									customResultsListClass={customResultsListClass}
									maxShow={maxShow}
									customListItemClass={customListItemClass}
									display={display}
									onSelect={onSelect} 
									options={options}
				  			/>
							)
	  				}
	  			})()}
  			</div>
  		</div>
		);
  }
}

export default SearchBarContainer;



// WEBPACK FOOTER //
// ./src/browser/components/ui/searchBar/searchBarContainer.js